module.exports = __webpack_public_path__ + "img/puberty-decal-19.a2934e69.png";